import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoginModal from './components/login-modal/login-modal';
import AuthenticatedApp from './components/authenticated-app/authenticated-app';
import { RecordingProvider } from "./contexts/RecordingContext";
import { AudioPlaybackProvider } from './contexts/PlaybackContext';
import { ChecklistProvider } from './contexts/ChecklistContext';
import { WebsocketProvider } from "./contexts/WebsocketContext";

function App() {
  const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === 'true';

  if (isAuthDisabled) {
    return (
      <ChecklistProvider>
        <div className="container" id="container">
          <AudioPlaybackProvider>
            <RecordingProvider>
              <AuthenticatedApp />
            </RecordingProvider>
          </AudioPlaybackProvider>
        </div>
      </ChecklistProvider>
    );
  }

  return (
    <ChecklistProvider>
      <div className="container" id="container">
        <UnauthenticatedTemplate>
          <LoginModal />
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <WebsocketProvider>
            <AudioPlaybackProvider>
              <RecordingProvider>
                <AuthenticatedApp />
              </RecordingProvider>
            </AudioPlaybackProvider>
          </WebsocketProvider>
        </AuthenticatedTemplate>
      </div>
    </ChecklistProvider>
  )
}

export default App
